module.exports = __webpack_public_path__ + "media/alaska/boat-3c468f92.jpg";